module.exports = __webpack_public_path__ + "img/CellCycle-INCA_10X_IC.64ec5deb.png";